enum RelatedTasksMode {
  ContributingTasks = 'contributing_tasks',
  ContributingEpics = 'contributing_epics',
  ContributingTeams = 'contributing_teams',
  ContributingInitiatives = 'contributing_initiatives',
  ContributingOutcomes = 'contributing_outcomes',
}

export { RelatedTasksMode };
